import React from 'react';
import PropTypes from 'prop-types';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';

const BreadcrumbItem = ({ to, children }) => {
  return(
    <BreadcrumbsItem to={ to }>{ children }</BreadcrumbsItem>
  )
}

BreadcrumbItem.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string.isRequired
};

export default BreadcrumbItem;
